import { PageIntro } from "@/components/kit/PageIntro";
import { FounderStory } from "@/components/blocks/FounderStory";
import { StoriesGrid } from "@/components/blocks/StoriesGrid";
import { ReviewStrip } from "@/components/home/ReviewStrip";
import { CtaBand } from "@/components/kit/CtaBand";
import { usePageMeta } from "@/components/site/Seo";
import { SITE } from "@/lib/content";

export default function Stories() {
  usePageMeta("Success Stories", `Real people, real progress, shared with consent. Founder Sony Mathew lost ${SITE.founderKg} kg. ${SITE.disclaimer}`);
  return (
    <div data-testid="stories-page">
      <PageIntro testId="stories-hero" eyebrow="Success stories" lines={["Real People.", <em key="r" className="text-gold-soft">Real Progress.</em>]} intro={`Every story here is shared with the person's written consent. ${SITE.disclaimer}`} script="Healthier · Happier · Stronger" />
      <FounderStory />
      <section className="bg-forest-deep py-24 text-cream sm:py-28"><div className="wrap"><StoriesGrid limit={6} /></div></section>
      <ReviewStrip />
      <CtaBand testId="stories-cta" title={["Start your", "journey today."]} />
    </div>
  );
}
